import { render, staticRenderFns } from "./CertifcationCard.vue?vue&type=template&id=5b7d9453"
import script from "./CertifcationCard.vue?vue&type=script&lang=ts"
export * from "./CertifcationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b7d9453')) {
      api.createRecord('5b7d9453', component.options)
    } else {
      api.reload('5b7d9453', component.options)
    }
    module.hot.accept("./CertifcationCard.vue?vue&type=template&id=5b7d9453", function () {
      api.rerender('5b7d9453', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/certifications/CertifcationCard.vue"
export default component.exports